import { render, staticRenderFns } from "./Nourish2025AppFlow.vue?vue&type=template&id=56a1966d&scoped=true"
import script from "./Nourish2025AppFlow.vue?vue&type=script&lang=js"
export * from "./Nourish2025AppFlow.vue?vue&type=script&lang=js"
import style0 from "./Nourish2025AppFlow.vue?vue&type=style&index=0&id=56a1966d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a1966d",
  null
  
)

export default component.exports